import TableSearch from '@rio-cloud/rio-uikit/TableSearch';

type SearchInputProps = {
    id?: string;
    value: string;
    onSearch: (value: string) => void;
    placeholder?: string;
};

export const SearchInput = ({ id, value, onSearch, placeholder = 'Search' }: SearchInputProps) => {
    return <TableSearch id={id} placeholder={placeholder} value={value} onChange={onSearch} />;
};
